import React from 'react'
import { Spinner } from 'react-bootstrap'

const AnalyticsPdfLoadingState = () => (
  <div className="text-center p-5">
    <Spinner animation="border" variant="primary" />
  </div>
)

export default AnalyticsPdfLoadingState
